import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube, Send, Twitter, MessageCircle } from 'lucide-react';
import { WaChannelLink } from '../lib/whatsappChannel';

const Footer = () => {
  return (
    <footer className="bg-[#051211] border-t border-white/5 py-16">
      <div className="container mx-auto px-6 flex flex-col items-center text-center">

        {/* Brand Logo */}
        <Link to="/" className="inline-block mb-6 hover:opacity-80 transition-opacity">
          <img
            src="https://customer-assets.emergentagent.com/job_clean-menu-design/artifacts/iazr7n03_cropped-Green-removebg-preview.png"
            alt="Thuba Logo"
            className="h-20 w-auto object-contain"
          />
        </Link>

        {/* Description */}
        <p className="text-muted-foreground leading-relaxed mb-8 max-w-xl">
          Menebar manfaat melalui dakwah, sosial, pendidikan, dan pemberdayaan sesuai dengan nilai-nilai ke Islaman.
        </p>

        {/* Horizontal Menu - Centered */}
        <div className="flex flex-wrap justify-center gap-8 md:gap-12 mb-10">
          {[
            { label: 'Tentang Kami', path: '/about' },
            { label: 'Ekosistem', path: '/ecosystem' },
            { label: 'Program', path: '/program' },
            { label: 'Media', path: '/media' },
            { label: 'Kontak', path: '/contact' }
          ].map((item) => (
            <Link
              key={item.label}
              to={item.path}
              className="text-white hover:text-gold transition-colors text-sm font-medium tracking-widest uppercase relative group"
            >
              {item.label}
              <span className="absolute -bottom-2 left-1/2 w-0 h-[1px] bg-gold group-hover:w-full transition-all duration-300 -translate-x-1/2"></span>
            </Link>
          ))}
        </div>

        {/* Social Icons */}
        <div className="flex flex-wrap justify-center gap-6 mb-12">
          <a href="https://instagram.com/thubaproject/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-gold transition-colors transform hover:-translate-y-1 duration-300"><Instagram size={24} /></a>
          <a href="https://facebook.com/thubaproject" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-gold transition-colors transform hover:-translate-y-1 duration-300"><Facebook size={24} /></a>
          <a href="https://www.youtube.com/@ThubaProject/streams" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-gold transition-colors transform hover:-translate-y-1 duration-300"><Youtube size={24} /></a>
          <a href="https://tiktok.com/@thuba.project" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-gold transition-colors transform hover:-translate-y-1 duration-300">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" /></svg>
          </a>
          <a href="https://threads.com/@thubaproject" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-gold transition-colors transform hover:-translate-y-1 duration-300"><span className="font-bold text-xl">@</span></a>
          <a href="https://x.com/thubaproject" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-gold transition-colors transform hover:-translate-y-1 duration-300"><Twitter size={24} /></a>
          <a href="https://t.me/thubaproject" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-gold transition-colors transform hover:-translate-y-1 duration-300"><Send size={24} /></a>
          <WaChannelLink className="text-muted-foreground hover:text-gold transition-colors transform hover:-translate-y-1 duration-300"><MessageCircle size={24} /></WaChannelLink>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 w-full pt-8 flex flex-col items-center gap-2 text-sm text-muted-foreground/60">
          <p>&copy; 2026 Thuba Project. Dedicated to building the Ummah.</p>
          <p className="font-serif italic text-xs tracking-wider">Faith. Focus. Create.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
